<template>
  <div v-if="epak !== undefined">
    <apexchart
      v-if="show"
      v-bind:epak="epak"
      :type="epak.type"
      height="200"
      :options="chartData.apexchartOptions"
      :series="chartData.series"
    >
    </apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
export default {
  name: "VueApexChart",
  components: {
    apexchart: VueApexCharts,
  },
  props: ["epak"],
  data() {
    return {
      show: false,
      chartData: {
        id: 1,
        series: this.epak.total_params,
        chartTitle: "Apex",
        dataLabels: { enabled: false },

        apexchartOptions: {
          series: this.epak.total_params,
          zoom: {
            enabled: true,
            autoScaleYaxis: true,
          },
          chart: {
            stacked: true,
            toolbar: {
              show: true,

              autoSelected: "zoom",
            },

            zoom: {
              enabled: true,
              autoScaleYaxis: true,
            },
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                legend: {
                  position: "right",
                  showForSingleSeries: true,
                  offsetY: 40,
                },
              },
            },
          ],
          plotOptions: {
            bar: {
              horizontal: false,
              borderRadius: 2,
              columnWidth: "20%",
            },
          },
          yaxis: {
            decimalsInFloat: 0,
            forceNiceScale: true,
            labels: {
              formatter: function(val) {
                return val;
              },
            },
            title: {
              text: this.epak.title_text,
            },
          },

          xaxis: {
            type: "string",
            categories: this.epak.dates,
            convertedCatToNumeric: false,
            title: this.epak.xaxisTitle,
            axisBorder: this.epak.xaxisBorder,
          },
          legend: {
            position: this.epak.position,
            horizontalAlign: this.epak.horizontalAlign,
            marginLeft: this.epak.marginLeft,
            showForSingleSeries: true,
            markers: { radius: 12 },
          },
          fill: {
            opacity: 1,
          },
        },
      },
    };
  },
  mounted() {
    if (this.epak !== null && this.epak !== undefined) {
      this.show = true;
      // this.chartData.apexchartOptions.series = this.epak.total_params
      // this.chartData.series = this.epak.total_params
      // this.chartData.apexchartOptions.xaxis.categories =this.epak.dates
      // this.chartData.apexchartOptions.chart.type = this.epak.dates
      // this.chartData.apexchartOptions.yaxis.title.text=this.epak.title_text
      // this.chartData.apexchartOptions.legend.position=this.epak.position
      // this.chartData.apexchartOptions.legend.horizontalAlign=this.epak.horizontalAlign
      // this.chartData.apexchartOptions.legend.marginLeft=this.epak.marginLeft
      // this.chartData.apexchartOptions.xaxis.title =this.epak.xaxisTitle
      // this.chartData.apexchartOptions.xaxis.axisBorder= this.epak.xaxisBorder
    } else {
      if (this.apq !== null && this.apq !== undefined) {
        console.log("changes");
      }
    }
  },
};
</script>
